export enum VisitorDashboardDataTypes {
  // Visitor Stats
  ThisWeek = 'ThisWeek',
  NextWeek = 'NextWeek',
  LastWeek = 'LastWeek',
  ThisYear = 'ThisYear',
}
